import Event from '../../core/Event';
import EstimationPeriod from '../../../domain/EstimationPeriod';

export default class EstimationPeriodUpdateRequested extends Event {
    public static type = 'EstimationPeriodUpdateRequested';

    constructor(public readonly estimationPeriod: EstimationPeriod) {
        super(EstimationPeriodUpdateRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/admin/events/EstimationPeriodUpdateRequested.ts